module.exports = __webpack_public_path__ + "img/img05.cca3d20a.jpg";